/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreatePlaceDto } from '../models/CreatePlaceDto';
import type { PatchPlaceDraftDto } from '../models/PatchPlaceDraftDto';
import type { PlaceClaimReviewDto } from '../models/PlaceClaimReviewDto';
import type { PlaceContentVersionDto } from '../models/PlaceContentVersionDto';
import type { PlaceDeletedDto } from '../models/PlaceDeletedDto';
import type { PlaceEditorDto } from '../models/PlaceEditorDto';
import type { PlaceIndexingOverrideDto } from '../models/PlaceIndexingOverrideDto';
import type { PlaceLockVersionDto } from '../models/PlaceLockVersionDto';
import type { PlacePointCandidateDto } from '../models/PlacePointCandidateDto';
import type { PlaceRequestChangesDto } from '../models/PlaceRequestChangesDto';
import type { PlaceRouteCandidateDto } from '../models/PlaceRouteCandidateDto';
import type { PlaceSectionReviewInputDto } from '../models/PlaceSectionReviewInputDto';
import type { PlaceSlugAvailabilityDto } from '../models/PlaceSlugAvailabilityDto';
import type { PlaceUnpublishDto } from '../models/PlaceUnpublishDto';
import type { PlaceWorkItemDto } from '../models/PlaceWorkItemDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminPlacesService {
  /**
   * @returns PlaceWorkItemDto
   * @throws ApiError
   */
  public static adminPlacesControllerList(): CancelablePromise<Array<PlaceWorkItemDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/places',
    });
  }
  /**
   * @param requestBody
   * @returns PlaceEditorDto
   * @throws ApiError
   */
  public static adminPlacesControllerCreate(
    requestBody: CreatePlaceDto,
  ): CancelablePromise<PlaceEditorDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/places',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param query
   * @param limit
   * @returns PlacePointCandidateDto
   * @throws ApiError
   */
  public static adminPlacesControllerPoints(
    query: string = '',
    limit: number = 20,
  ): CancelablePromise<Array<PlacePointCandidateDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/places/point-candidates',
      query: {
        query: query,
        limit: limit,
      },
    });
  }
  /**
   * @param slug
   * @param placeId
   * @returns PlaceSlugAvailabilityDto
   * @throws ApiError
   */
  public static adminPlacesControllerSlugAvailability(
    slug: string,
    placeId?: string,
  ): CancelablePromise<PlaceSlugAvailabilityDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/places/slug-availability',
      query: {
        slug: slug,
        placeId: placeId,
      },
    });
  }
  /**
   * @param id
   * @returns PlaceEditorDto
   * @throws ApiError
   */
  public static adminPlacesControllerEditor(id: string): CancelablePromise<PlaceEditorDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/places/{id}',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @param requestBody
   * @param ifMatch Optional quoted draft lockVersion or public contentVersion.
   * @returns PlaceDeletedDto
   * @throws ApiError
   */
  public static adminPlacesControllerDelete(
    id: string,
    requestBody: PlaceLockVersionDto,
    ifMatch?: string,
  ): CancelablePromise<PlaceDeletedDto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/admin/places/{id}',
      path: {
        id: id,
      },
      headers: {
        'If-Match': ifMatch,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @param requestBody
   * @param ifMatch Optional quoted draft lockVersion or public contentVersion.
   * @returns PatchPlaceDraftDto
   * @throws ApiError
   */
  public static adminPlacesControllerGenerateAi(
    id: string,
    requestBody: PlaceLockVersionDto,
    ifMatch?: string,
  ): CancelablePromise<PatchPlaceDraftDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/places/{id}/generate-ai',
      path: {
        id: id,
      },
      headers: {
        'If-Match': ifMatch,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @param requestBody
   * @param ifMatch Optional quoted draft lockVersion or public contentVersion.
   * @returns PlaceEditorDto
   * @throws ApiError
   */
  public static adminPlacesControllerPatch(
    id: string,
    requestBody: PatchPlaceDraftDto,
    ifMatch?: string,
  ): CancelablePromise<PlaceEditorDto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/admin/places/{id}/draft',
      path: {
        id: id,
      },
      headers: {
        'If-Match': ifMatch,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @returns PlaceRouteCandidateDto
   * @throws ApiError
   */
  public static adminPlacesControllerListRouteCandidates(
    id: string,
  ): CancelablePromise<Array<PlaceRouteCandidateDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/admin/places/{id}/route-candidates',
      path: {
        id: id,
      },
    });
  }
  /**
   * @param id
   * @param requestBody
   * @param ifMatch Optional quoted draft lockVersion or public contentVersion.
   * @returns PlaceEditorDto
   * @throws ApiError
   */
  public static adminPlacesControllerAcceptMapSnapshot(
    id: string,
    requestBody: PlaceLockVersionDto,
    ifMatch?: string,
  ): CancelablePromise<PlaceEditorDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/places/{id}/map-snapshot/accept',
      path: {
        id: id,
      },
      headers: {
        'If-Match': ifMatch,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @param claimId
   * @param requestBody
   * @param ifMatch Optional quoted draft lockVersion or public contentVersion.
   * @returns PlaceEditorDto
   * @throws ApiError
   */
  public static adminPlacesControllerClaimReview(
    id: string,
    claimId: string,
    requestBody: PlaceClaimReviewDto,
    ifMatch?: string,
  ): CancelablePromise<PlaceEditorDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/places/{id}/claims/{claimId}/review',
      path: {
        id: id,
        claimId: claimId,
      },
      headers: {
        'If-Match': ifMatch,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @param requestBody
   * @param ifMatch Optional quoted draft lockVersion or public contentVersion.
   * @returns PlaceEditorDto
   * @throws ApiError
   */
  public static adminPlacesControllerIndexingOverride(
    id: string,
    requestBody: PlaceIndexingOverrideDto,
    ifMatch?: string,
  ): CancelablePromise<PlaceEditorDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/places/{id}/indexing-override',
      path: {
        id: id,
      },
      headers: {
        'If-Match': ifMatch,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @param requestBody
   * @param ifMatch Optional quoted draft lockVersion or public contentVersion.
   * @returns PlaceEditorDto
   * @throws ApiError
   */
  public static adminPlacesControllerSectionReview(
    id: string,
    requestBody: PlaceSectionReviewInputDto,
    ifMatch?: string,
  ): CancelablePromise<PlaceEditorDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/places/{id}/section-reviews',
      path: {
        id: id,
      },
      headers: {
        'If-Match': ifMatch,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @param requestBody
   * @param ifMatch Optional quoted draft lockVersion or public contentVersion.
   * @returns PlaceEditorDto
   * @throws ApiError
   */
  public static adminPlacesControllerSubmit(
    id: string,
    requestBody: PlaceLockVersionDto,
    ifMatch?: string,
  ): CancelablePromise<PlaceEditorDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/places/{id}/submit',
      path: {
        id: id,
      },
      headers: {
        'If-Match': ifMatch,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @param requestBody
   * @param ifMatch Optional quoted draft lockVersion or public contentVersion.
   * @returns PlaceEditorDto
   * @throws ApiError
   */
  public static adminPlacesControllerChanges(
    id: string,
    requestBody: PlaceRequestChangesDto,
    ifMatch?: string,
  ): CancelablePromise<PlaceEditorDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/places/{id}/request-changes',
      path: {
        id: id,
      },
      headers: {
        'If-Match': ifMatch,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @param requestBody
   * @param ifMatch Optional quoted draft lockVersion or public contentVersion.
   * @returns PlaceEditorDto
   * @throws ApiError
   */
  public static adminPlacesControllerPublish(
    id: string,
    requestBody: PlaceLockVersionDto,
    ifMatch?: string,
  ): CancelablePromise<PlaceEditorDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/places/{id}/publish',
      path: {
        id: id,
      },
      headers: {
        'If-Match': ifMatch,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @param requestBody
   * @param ifMatch Optional quoted draft lockVersion or public contentVersion.
   * @returns PlaceEditorDto
   * @throws ApiError
   */
  public static adminPlacesControllerUnpublish(
    id: string,
    requestBody: PlaceUnpublishDto,
    ifMatch?: string,
  ): CancelablePromise<PlaceEditorDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/places/{id}/unpublish',
      path: {
        id: id,
      },
      headers: {
        'If-Match': ifMatch,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param id
   * @param requestBody
   * @param ifMatch Optional quoted draft lockVersion or public contentVersion.
   * @returns PlaceEditorDto
   * @throws ApiError
   */
  public static adminPlacesControllerRestore(
    id: string,
    requestBody: PlaceContentVersionDto,
    ifMatch?: string,
  ): CancelablePromise<PlaceEditorDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/admin/places/{id}/restore',
      path: {
        id: id,
      },
      headers: {
        'If-Match': ifMatch,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
